// extracted by mini-css-extract-plugin
export default {"container":"RestockStatus_container__437wU","positive":"RestockStatus_positive__95Y-X"};